<template>
  <div v-if="isSectionVisible">
    <section-title highlight>
      Click a tile to start a company
<!--      <template v-slot:action>-->
<!--        <o-button>No Thanks</o-button>-->
<!--      </template>-->

    </section-title>

    <div class="tile-container">
      <game-tile
        v-for="hotelId in sortedCompanies"
        :key="hotelId"
        :hotel-id="hotelId"
        :is-child-hotel="false"
        :hidden="isHidden(hotelId)"
        @click="onClickTile"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {NS_GAME_STATE, NS_TURN_STATE} from "@/store/constants";
import GameTile from "@/components/board/GameTile";
import SectionTitle from "@/components/SectionTitle";

export default {
  name: 'NewCompanySection',

  components: {
    SectionTitle,
    GameTile,
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'hotelsAvailableForNewCompany',
      'stocksSortedByStartingPrice',
      'isNewCompany',
      'isMyTurn',
    ]),

    sortedCompanies() {
      return this.stocksSortedByStartingPrice.map(hotel => {
        return hotel.id;
      });
    },

    isSectionVisible() {
      return this.isNewCompany && this.isMyTurn;
    },
  },

  methods: {
    ...mapActions(NS_TURN_STATE, [
      'flowCompletePlacingNewCompany',
    ]),

    isHidden(hotelId) {
      return !this.hotelsAvailableForNewCompany.includes(hotelId);
    },

    onClickTile(options) {
      this.flowCompletePlacingNewCompany(options.hotelId);
    }
  }
}
</script>

<style scoped>
.tile-container {
  display: flex;
  justify-content: space-around;
  margin: 10px 5px;
}
</style>
